import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import * as momenttz from 'moment-timezone';
import { environment } from '@env/environment';

const Globalize = require('globalize');

@Pipe({
  name: 'localDate',
})
export class LocalDatePipe implements PipeTransform {
  transform(value: Date | null, format = 'yMMdd', timezoneConversion = false) {
    if (!value) {
      return '';
    }
    const formatter = Globalize.dateFormatter({ skeleton: format });

    if (timezoneConversion && !isNaN(value.getTime())) {
      const utcTime = momenttz.utc(value, 'YYYY-MM-DD[T]HH:mm:ss');
      const convertedTime = utcTime.clone().tz(environment.languageTimezone);
      return formatter(
        new Date(convertedTime.year(), convertedTime.month(), convertedTime.date(), convertedTime.hour(), convertedTime.minute(), convertedTime.seconds())
      );
    } else {
      const date = moment(value);
      return formatter(date.toDate());
    }
  }
}
